/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 31,
  image: "default-changelog-v2.png",
  title: "Compute SDK, CDN Improvements, Github Action, Faster Compute Deployments",
  shortDescription: "We have published a new Compute SDK. Enhanced the infrastructure of Compute Organizations. Released a custom Github Action for updating Cluster Instances. Improved the CDN",
  description: "We have published a new Compute SDK. Enhanced the infrastructure of Compute Organizations. Released a custom Github Action for updating Cluster Instances. Improved the CDN",
  date: "May 26th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Storage", "SDK", "Browser-Upload", "FNS"]
};
export const content = `
## [Compute SDK](https://www.npmjs.com/package/@spheron/compute)
- Introducing [@spheron/compute](https://www.npmjs.com/package/@spheron/compute) package for effective interaction with Spheron Compute organization directly from your application.

- Functionality includes deploying instances, updating them, checking logs, attaching domains, deploying applications from the marketplace, and viewing organization usage statistics.

- Provides programmatic management of computational needs, previously only available through the Spheron Compute website.

- Secure access token stored on the backend server for control over authorized operations.

- Refer to the [README](https://www.npmjs.com/package/@spheron/compute) in _@spheron/compute_ or the [documentations](https://docs.spheron.network/sdk/compute/) for more information.

## Compute Architecture Enhancements

- Improved architecture of parallel transaction component for Akash network in the compute system.

- Enhancements aimed at scalability and faster deployments.

- Minimized queue times, reducing user wait time.

- Enhances overall user experience.

- Supports robust and high-performing environment for computational needs.

## [Instance Update Github Action](https://github.com/marketplace/actions/instance-update-action)

- Released GitHub Action for updating Cluster Instances in the GitHub Marketplace.

- Seamlessly update Cluster Instances from the GitHub workflow environment.

- Simplifies deployment and maintenance without switching tools or platforms.

- Enables efficient infrastructure management and software development.

- Integrate the [Instance Update Github Action](https://github.com/marketplace/actions/instance-update-action) from the GitHub Marketplace for a streamlined development process.

## CDN Improvements

- Added CORS headers for seamless cross-origin resource sharing.

- Fixed issue with optimized images triggering incorrect downloads.

`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
